import React, { FC, PropsWithChildren } from 'react';
import './AdminTableStub.scss';

export const AdminTableStub: FC<PropsWithChildren> = ({ children }) => {
  return <div className="AdminTableStub">{children}</div>;
};
